<script setup lang="ts">
import { addTabKey, removeTabKey, stateKey, updateTabCountKey, updateTabKey } from '@/components/App/Tabs/types'
interface IProps {
  name: string
  count?: number
}

const props = withDefaults(defineProps<IProps>(), { count: undefined })
const { name, count } = toRefs(props)

const tabsState = inject(stateKey)
const addTab = inject(addTabKey)
const updateTab = inject(updateTabKey)
const removeTab = inject(removeTabKey)
const updateTabCount = inject(updateTabCountKey)

const isActive = computed(() => {
  return tabsState?.activeTab === tabsState?.tabs.indexOf(name.value)
})

watch(name, (newName) => {
  updateTab?.(name.value, newName)
})

watch(count, (newCount: number | undefined) => {
  updateTabCount?.(name.value, newCount)
})

onBeforeMount(() => addTab?.(name.value))
onBeforeUnmount(() => removeTab?.(name.value))
</script>

<template>
  <section v-if="$slots.default" v-show="isActive">
    <slot />
  </section>
</template>
